import * as React from 'react';
import { styled } from '@linaria/react';
import { Brand } from '@daedalus/core/src/brand/types';
import { getProviderIcon, getSvgProviderLogo } from '@daedalus/core/src/offer/business/provider';
interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** Brand configuration. It can be one of our brands or a white-label brand. */
  brand: Brand;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Whether to display the compact version */
  compact?: boolean;
  /** Whether to display the white-text variant of the logo. Only used if `compact` is `false` and the brand is `vio`. */
  withWhiteText?: boolean;
  /** Whether to display the icon with text. Only used if `compact` is `true` and the brand is `vio`. */
  withIconText?: boolean;
}
const LogoImageElement = /*#__PURE__*/styled('img')({
  name: "LogoImageElement",
  class: "loyxp7e",
  propsAsIs: false
});
const BrandIcon = ({
  withIconText,
  brand,
  className,
  ...imageProps
}: Omit<Props, 'withWhiteText' | 'compact'>) => <LogoImageElement title={brand.name} src={getProviderIcon({
  providerCode: brand.code,
  withText: withIconText
})} className={className} {...imageProps} />;
const BrandFullLogo = ({
  brand,
  withWhiteText,
  className,
  ...imageProps
}: Omit<Props, 'withIconText' | 'compact'>) => <LogoImageElement title={brand.name} src={getSvgProviderLogo({
  providerCode: brand.code,
  withWhiteText
})} className={className} {...imageProps} />;
export const BrandLogo = ({
  brand,
  compact = false,
  className,
  withWhiteText = false,
  withIconText = false,
  height = 30,
  ...imageProps
}: Props) => compact ? <BrandIcon brand={brand} withIconText={withIconText} className={className} height={height} {...imageProps} /> : <BrandFullLogo brand={brand} withWhiteText={withWhiteText} className={className} height={height} {...imageProps} />;

require("./BrandLogo.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./BrandLogo.tsx");